import { render, staticRenderFns } from "./KomoditiMainMap.vue?vue&type=template&id=4264778d&scoped=true"
import script from "./KomoditiMainMap.vue?vue&type=script&lang=js"
export * from "./KomoditiMainMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264778d",
  null
  
)

export default component.exports